<template>
  <div>
    <div class="none cursors float-right" @click="handleOpen">
      <i class="el-icon-info" style="font-size: 20px"></i>
    </div>
    <el-dialog
      :title="`Unidades de enfriamiento`"
      :visible.sync="modals.read"
      :close-on-click-modal="false"
      top="2%"
    >
      <div class="mb-5" style="word-break: break-word">
        <p>
          <small>
            {{ $t('info_climates.chilling_unit_explanation') }}
          </small>
        </p>
        <h6 class="mt-1 mb-2">
          <strong>{{ $t('climate.max_temperature_lower_threshold') }}</strong>
        </h6>
        <p>
          <small>
            {{ $t('info_climates.max_temperature_info') }}
          </small>
        </p>
        <h6 class="mt-1 mb-2">
          <strong>{{ $t('common_words.example') }}</strong>
        </h6>
        <p>
          <small>
            {{ $t('info_climates.established_max_temperature') }}
            <strong> {{ $t('info_climates.established_degree') }}</strong>
            {{ $t('info_climates.lower_threshold') }}
            <strong> {{ $t('info_climates.lower_threshold_degree') }}</strong>
            {{ $t('info_climates.average_temperature') }}
            <strong> {{ $t('info_climates.average_degree') }}</strong
            >.
          </small>
        </p>
        <h6 class="mt-1 mb-2">
          <strong> {{ $t('info_climates.chilling_hours') }}</strong>
        </h6>
        <p>
          <small>
            {{ $t('info_climates.chilling_hours_info') }}
            <strong> {{ $t('info_climates.chilling_hours_degree') }}</strong
            >{{ $t('info_climates.definitions') }}
          </small>
        </p>
        <h6 class="mt-1 mb-2">
          <strong>{{ $t('info_climates.utah_model') }}</strong>
        </h6>
        <p>
          <small>
            {{ $t('info_climates.utah_model_info') }}
          </small>
        </p>
        <h6 class="mt-1 mb-2">
          <strong>{{
            $t('info_climates.chilling_relative_effectiveness')
          }}</strong>
        </h6>
        <p>
          <small>
            {{ $t('info_climates.relative_effectiveness_info')
            }}<strong>{{
              $t('info_climates.relative_effectiveness_degree')
            }}</strong
            >.
          </small>
        </p>
        <h6 class="mt-1 mb-2">
          <strong>{{
            $t('info_climates.chillness_negative_accumulation')
          }}</strong>
        </h6>
        <p>
          <small>
            {{ $t('info_climates.chillness_negative_accumulation_info') }}
            <strong>{{
              $t('info_climates.chillness_negative_accumulation_degree')
            }}</strong
            >.
          </small>
        </p>
        <h6 class="mt-1 mb-2">
          <strong>{{
            $t('info_climates.units_model_positive_chilling')
          }}</strong>
        </h6>
        <p>
          <small>
            {{ $t('info_climates.units_model_positive_chilling_info') }}
            <strong>{{ $t('info_climates.pcu') }}</strong>
            {{ $t('info_climates.utah_model_modification')
            }}<strong>{{ $t('info_climates.pcu') }}</strong>
            {{ $t('info_climates.no_accounted_values') }}
          </small>
        </p>
        <h6 class="mt-1 mb-2">
          <strong>{{ $t('info_climates.practical_application') }}</strong>
        </h6>
        <p>
          <small>
            {{ $t('info_climates.chilling_unit_use') }}
          </small>
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'info-chilling-unit',
  data() {
    return {
      modals: {
        read: false,
      },
    };
  },
  methods: {
    handleOpen() {
      this.modals.read = true;
    },
  },
};
</script>
